module.exports = __webpack_public_path__ + "static/media/options-2.d7a9758e.svg";